
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import CertExample from "./components/cert-example.vue";

import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import { pblList } from "@/apis/home";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import ApplyFormDialog from "@/components/ApplyFormDialog.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";

@Component({
  components: {
    ApplyForm,
    PictureSlide,
    CertExample,

    Breadcrumb,
    ApplyFormDialog
  }
})
export default class InternalTraining extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "光华研修班 | CHO班·EMBA班·PMP班·CGO班·新媒体营销师班等八大研修班 - 光华赋能",
      description:
        "光华研修班涵盖八大研修班：首席人力官(CHO)班、职业经理人EMBA班、PMP项目经理班、首席增长官(CGO)班、新媒体营销师班、企业精益生产认证班、新晋管理者班、财税合规师班，系统提升管理能力。",
      keywords:
        "光华研修班,CHO班,EMBA班,PMP班,CGO班,新媒体营销,精益生产,新晋管理者,财税合规,管理研修班,光华赋能",
      path: "/mba",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "光华商学院" },
        { name: "光华研修班" }
      ],
      jsonLd: getServiceJsonLd({
        name: "光华研修班",
        description:
          "涵盖CHO、EMBA、PMP、CGO、新媒体营销、精益生产、新晋管理者、财税合规等八大研修班的系统管理培训。",
        category: "管理研修班培训"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  List = [
    { title: "光华商学院", url: "" },
    { title: "光华研修班", url: "" }
  ];
  picTop = "/img/d95f617ccc112ba564a605fe6a27c64f.png";
  picBottom = "/img/9d7c19efdb3ad3650b20358bfe4da517.png";
  pic11 = "/img/ca3c0c7c5d4b094a12b1309b561d0cf7.png";
  pic12 = "/img/c08c70e5d93ea640e791c9b6b698f4df.png";
  pic13 = "/img/898b3b4262dac5bf39e91d02e179c76f.png";

  pic21 = "/img/b829aac1cf04776019268a246a6ee25f.png";
  pic22 = "/img/10804a7843c4ea7ec91a5ac43cda7992.png";

  pic31 = "/img/8baea9a25aba0168fee1727bd0bca478.png";
  pic32 = "/img/9adce99afa5961447c4f6019ea89926e.png";
  pic33 = "/img/d6ef2352db65748c001d7254db18c618.png";

  pic41 = "/img/9dfbc751a81078f191a7bfc5fd361ed5.png";
  pic42 = "/img/8000fd203a183560868e8ac5c77300c6.png";

  pic51 = "/img/f7742816015f80569293cebe429a7fcb.png";
  pic52 = "/img/6a27bf3e7c134002e2ed6bde7cc92dfb.png";

  pic61 = "/img/27300eed7a7fae07b18ff51a2a30a02c.png";
  pic62 = "/img/037ae59072f6274e1cb2cfef086f5ee8.png";

  pic71 = "/img/eb11f1b7c516d8463d3c8a43df2d4ac2.png";
  pic72 = "/img/45be9a0c380c97f7fabd72a37429c29f.png";

  pic81 = "/img/96ec8ac44c0af9eb6e311e6e2e989ef6.png";
  pic82 = "/img/cf525d27425f6a848daf151b3e054db9.png";

  currentIndex = 0;
  animationStatus = false;
  animationStatus2 = false;
  pbl_info = {};
  pbl_id = "" as any;
  list = [] as any;
  show = false;
  dialogClose() {
    this.animationStatus = false;
    this.animationStatus2 = false;
  }
  created() {
    // pblList
    this.pblList();
  }
  async pblList() {
    let data = await pblList({
      per_page: 45,
      page: 1
    });
    if (data) {
      this.list = data.list || [];
      if (this.list.length) {
        this.pbl_id = this.list[0].pbl_id;
      }
    }

    console.log("pblList", data.list);
  }

  changeTab(index: any) {
    this.currentIndex = index;
    this.pbl_id = this.list[index].pbl_id;
  }

  showCert(index: any) {
    console.log("pbl_id", this.list[index]);
    this.pbl_id = this.list[index].pbl_id;
    console.log("pbl_id", this.pbl_id);
    this.pbl_info = this.list[index];
    if (this.pbl_id == 1) {
      console.log(123);

      this.animationStatus = true;
    } else {
      this.animationStatus2 = true;
      let cert = this.$refs.cert2 as any;
      console.log("cert", cert);

      cert.setPbl(this.pbl_info);
    }
  }

  submit() {
    this.show = true;
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华商学院，公开课,企业内训，公开课，企业培训,公开课培训网,时代光华公开课"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训，线下课程，管理培训，公开课培训,新员工培训，股权咨询，体系课程，管理课程，销售课程，HR课程，HRBP，运营课程，团队，领导力，AI，人工智能，办公效率提升，训战营，主播，全域营销，必修课，选修课，集训，实战，实操，实用，实地，实在，学，练，考，评，赛，实战运营，项目管理，战略，绩效，绩效体系，人才管理，AI+组织技能，组织发展，管理创新，财务，，学院，总裁，管理，人力，运营，职场，财务，生成，制造，宏观经济，战略/变革，组织发展，招聘面试，高层管理，基层管理，中层管理，管理创新，市场营销，薪酬绩效，培训体系，项目研发，财务管理，劳动法，数智化制造，仓储物流，生产计划，税务筹划，预算管控，职业技能，PPT，EXCEL，WORD，办公Office系列,TTT，市场营销，线上流量，私域流量，业务团队，平台流量，采购供应链，质量管理，精益生产，降本增效，应收账款，现场管理，班组长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
